import axios from 'axios'

const prefix = window.location.origin
const api = axios.create({
    withCredentials: true
})
export const loginCb = function () {
    return api({
        method: 'post',
        url: '/vipapi/login/callback',
    })
}
export const login = function (data, okCB) {
    return api({
        method: 'get',
        url: `/lg/login/chcode?t=${+new Date}` // ie会缓存接口
    }).then(function (res) {
        if (res.data.status !== 200) {
            return
        }
        /* eslint-disable */
        window.eval(res.data.data.chcode) 
        api({
            method: 'post',
            url: '/lg/login/user',
            // headers: {
            //     'Content-Type': 'application/json'
            // },
            // withCredentials: true,
            data: data
        }).then((response) => {
            okCB(response)
        }).catch((error) => {
            console.log(error)
        })
    })
}
export const getLoginPicture = function () {
    return prefix + '/lg/captcha/picture?random=' + (Math.random() * 100<<4)
}
export const commonCookie = function () {
    return api({
        method: 'get',
        url: `/lg/common/cookie?t=${+new Date}`
    })
}
// 获取手机号注册验证码
export const getmobileSmcode = function (data, okCB) {
    return api.get(`/lg/register/mobile/bind?t=${+new Date}`,{
        params: data
    }).then((response) => {
        okCB&&okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

//登录二次验证
export const getSmsLogin = function (data, okCB) {
    return api.post(`/lg/login/smslogin`,data).then((response) => {
        okCB&&okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

//登录二次验证请求短信验证码
export const getSmsCode = function (data, okCB) {
    return api.get(`/lg/login/sms_code`,{
        params: data
    }).then((response) => {
        okCB&&okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

// 获取登录手机验证码
export const getLoginMobileSmcode = function (data, okCB) {
    return api.get(`/lg/login/mobile/bind?t=${+new Date}`,{
        params: data
    }).then((response) => {
        okCB&&okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

export const checkLogin = function (data, okCB){
    return api({
        method: 'post',
        url: '/lg/login/check',
        data: data
    }).then((response) => {
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

export const mobileBind = function (data, okCB) {
    return api({
        method: 'post',
        url: '/lg/login/mobile/bind',
        data: data
    }).then((response) => {
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

// 校验账户名是否可用
export const userVerify = function (data, okCB) {
    return api({
        method: 'get',
        url: '/lg/register/user/verify?userid='+data,
    }).then((response) => {
        console.log(data)
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

export const register = function (data, okCB) {
    return api({
        method: 'get',
        url: `/lg/login/chcode?t=${+new Date}` // ie会缓存接口
    }).then(function (res) {
        if (res.data.status !== 200) {
            return
        }
        /* eslint-disable */
        window.eval(res.data.data.chcode)
        api({
            method: 'post',
            url: '/lg/register/user',
            data: data
        }).then((response) => {
            okCB(response)
        }).catch((error) => {
            console.log(error)
        })
    })
}

export const findpwdVerify = function (data, okCB) {
    return api({
        method: 'post',
        url: '/lg/findpwd/user/verify',
        data: data
    }).then((response) => {
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}
// 发送安全手机验证码（忘记密码）
export const getMobileSecureCode = function (data, okCB) {
    return api.get(`/lg/findpwd/mobile/secure_code?t=${+new Date}`,{
        params: data
    }).then((response) => {
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}
// 校验安全手机验证码
export const mobileSecureCode = function (data, okCB) {
    return api({
        method: 'post',
        url: '/lg/findpwd/mobile/secure_code',
        data: data
    }).then((response) => {
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}

export const SetNewPwd = function (data, okCB) {
    return api({
        method: 'post',
        url: '/lg/findpwd/user/password',
        data: data
    }).then((response) => {
        okCB(response)
    }).catch((error) => {
        console.log(error)
    })
}


// WEBPACK FOOTER //
// ./src/service/loginService.js